<div class="rich-text-editor-container" [class.readonly]="readonly">
  <quill-editor
    #quillEditor
    [style]="editorStyles"
    [placeholder]="placeholder"
    [readOnly]="readonly"
    [theme]="theme"
    [modules]="quillConfig?.modules"
    [formats]="quillConfig?.formats"
    (onContentChanged)="onContentChange($event.html)"
    (onEditorCreated)="onEditorCreated($event)"
    (onFocus)="onFocus()"
    (onBlur)="onBlur()"
    class="rich-text-editor">
  </quill-editor>

  <div class="editor-actions" *ngIf="!readonly && showSaveButton">
    <button
      type="button"
      class="save-button"
      (click)="onSave()"
      title="Save (Ctrl+S)">
      Save
    </button>
  </div>
</div>
